import React, {useCallback, useState} from 'react';
// import {connections} from "./data";
import {List} from "@mui/material";
import ListItemProfile from "../ListRowProfile/ListItemProfile";
import { useParams } from "react-router-dom";
import { ApiService } from 'app/servicesTwo/ApiService';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";

const ListRowProfile = ({ data , setAddStudents, updateProfileList, profileUser}) => {
    const { id } = useParams()
    const Swal = useSwalWrapper();
    const toast = (variant, message) => {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        });

        Toast.fire({
            icon: variant,
            title: message,
        });
    };

    const [itemsList, setItemsList] = useState(data);
    const includeStudentToClass = useCallback((record) => {
        try {
            ApiService.post(`/perfil/${id}/usuario/${record.pessoa_id}`)
            .then((response) => {
                let newArray = profileUser;
                record.usuario_perfil_id = response.data.usuario_perfil_id;
                newArray.push(record)
                updateProfileList(newArray);
                toast('success', 'Usuário adicionado com sucesso');
            })
            .catch((error) => {
              if (error.response) {
                  console.log(error.response.data);
                  toast('error', error.response.data.error);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('error', error.message);
                }
            })
        } catch (err) {
          console.log(err);
        }

    }, [itemsList]);

    return (
            <List disablePadding>
                {
                    itemsList.map((item, index) => (
                        <ListItemProfile item={item} key={index} includeStudentToClass={includeStudentToClass}/>
                    ))
                }
            </List>
    );
};

export default ListRowProfile;
